module.exports = __webpack_public_path__ + "static/img/bg1.bdf32bc5.png";